import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { AdminCreateTenantRequest } from '@naya/shared'
import { adminApi } from '../adminApi.js'
import { tenantsListKey } from './useTenants.js'
import type { CreateTenantResponse } from '../types.js'

export function useCreateTenant() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: AdminCreateTenantRequest) =>
      adminApi.post<CreateTenantResponse>('/tenants', input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: tenantsListKey })
    },
  })
}
